import { game } from '../main';
import { Popup } from './Popup';
import { createMultiLineText } from '../Components/MultiLineText';

export class PopupHelp extends Popup {
  constructor() {
    super();
    this.addTitle(game.getText(1));
    this.addButton(0, 280, 'button_big', game.getText(14), () => this.closeWindow());
    const helpTxt = createMultiLineText(0, -230, 'font', game.getText(22), 20, 480, 500, 'left', 0.5, 0);
    // @ts-ignore
    helpTxt.updateCache();
    this.addChild(helpTxt);
  }
}